import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from '../../shared/loader/loader.service';
import { navigateAndThrow } from '../service/error-util';
import { HttpContextToken } from '@angular/common/http';

export const SHOW_LOADER = new HttpContextToken<boolean>(() => true);

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const router = inject(Router);

  const shouldShowLoader = req.context.get(SHOW_LOADER);

  if (shouldShowLoader) {
    loaderService.show();
  }

  return next(req).pipe(
    catchError((error) => navigateAndThrow(router, 'Error !', error)),
    finalize(() => {
      if (shouldShowLoader) {
        setTimeout(() => loaderService.hide(), 500);
      }
    }),
  );
};
